import { render } from "./qualityUserScore.vue?vue&type=template&id=05fc2c1c&scoped=true"
import script from "./qualityUserScore.vue?vue&type=script&lang=js"
export * from "./qualityUserScore.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fc2c1c"]])

export default __exports__